import { render, staticRenderFns } from "./HalterForm.vue?vue&type=template&id=72b058e0&"
import script from "./HalterForm.vue?vue&type=script&lang=js&"
export * from "./HalterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports